import { Component } from '@angular/core';
import { ProjektService } from '../service';

@Component({
  selector: 'fa-kt-saved-projekt-filters',
  templateUrl: './saved-projekt-filters.component.html',
  styleUrls: ['./saved-projekt-filters.component.css'],
})
export class SavedProjektFiltersComponent {
  constructor(public projekt: ProjektService) {}
  /* << fields   */

  /*   fields >> */
  /* << methods   */

  /*   methods >> */
}
